export default __webpack_public_path__ + "static/media/office7full.3178bae9.jpg";